import React from 'react';
import ReactDOM from 'react-dom';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import chunk from 'lodash/chunk'
import compact from 'lodash/compact'
import difference from 'lodash/difference'
import differenceBy from 'lodash/differenceBy'
import includes from 'lodash/includes'
import indexOf from 'lodash/indexOf'

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';

import { OEMS } from '../data/Store'


const FORWARD_SLASHES = /\//g
const WRAPPING_FORWARD_SLASH = '/\u200B' // zero width space to allow wrapping


const styles = theme => ({
  formControl: {
    marginBottom: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
  },
  inputProps: {
    textAlign: 'right',
  }
});


class EquipmentBrandForm extends React.Component {

  state = {}

  state = {
    labelWidth1: 0,
    labelWidth2: 0,
    labelWidth3: 0,
  };

  componentDidMount() {
    const brand1 = ReactDOM.findDOMNode(this.Brand1Ref)
    const brand2 = ReactDOM.findDOMNode(this.Brand2Ref)
    const brand3 = ReactDOM.findDOMNode(this.Brand3Ref)

    if (brand1) {
      this.setState({
        labelWidth1: brand1.offsetWidth,
        labelWidth2: brand2.offsetWidth,
        labelWidth3: brand3.offsetWidth,
      });
    }
  }


  toggleOem = event => {
    const {order, actions} = this.props
    const {oems} = order

    const code = event.target.value
    const i = indexOf(oems, code)
    let newOems = oems.slice()

    if (i < 0) {
      newOems.push(code)
    } else {
      newOems.splice(i, 1)
    }
    actions.updateOrder(order, {oems: newOems})
  }


  oemSelected = code => {
    const {order} = this.props
    const {oems} = order

    const exists = !!includes(oems, code)

    return exists
  }


  setOem = (index, oemCode) => {
    const {actions, order} = this.props
    const {oems} = order

    let newOemList = oems.slice(0)
    newOemList[index] = oemCode
    actions.updateOrder(order, {oems: newOemList})
  }


  renderFieldEdgeOptions = () => {
    const thirds = Math.ceil(OEMS.length / 3)
    const oemChunks = chunk(OEMS, thirds)

    return (
      <Grid container>
        {
          oemChunks.map(arr => {
            return (
              arr.map(oem => (
                <Grid item key={oem.code} xs={12} sm={6} md={4}>
                  <FormControlLabel label={oem.name.replace(FORWARD_SLASHES, WRAPPING_FORWARD_SLASH)} control={
                    <Checkbox checked={this.oemSelected(oem.code)} onChange={this.toggleOem} value={oem.code} />
                  }/>
                </Grid>
              ))
            )
          })
        }
      </Grid>
    )
  }


  renderRegularOptions = () => {
    const {classes, order, showErrors} = this.props
    const { oems, _errors } = order

    // This code sets which oem options show up in each dropdown. When an oem
    // is selected in one dropdown, it is removed from the options shown in the
    // others, to prevent it from being picked more than once.
    let OEM_OPTIONS = OEMS.slice()
    OEM_OPTIONS.unshift({code: '', name: ''}) // Add an empty option to the top
    const selectedOems = compact(oems)
    const oemOptions = [
      differenceBy(OEM_OPTIONS, difference(selectedOems, [oems[0]]).map(c => ({code: c})), 'code'),
      differenceBy(OEM_OPTIONS, difference(selectedOems, [oems[1]]).map(c => ({code: c})), 'code'),
      differenceBy(OEM_OPTIONS, difference(selectedOems, [oems[2]]).map(c => ({code: c})), 'code'),
    ]

    return (
      <Grid container>
        <Grid item xs={12} sm={4} md={3}>
        <FormControl fullWidth variant="outlined" className={classes.formControl}>
          <InputLabel required ref={ref => { this.Brand1Ref = ref }} htmlFor="brand1" >
            My #1 brand is:
          </InputLabel>
          <Select
            variant="outlined"
            error={!!(showErrors && _errors.oems)}
            value={oems[0] || ''}
            onChange={e => this.setOem(0, e.target.value)}
            input={
              <OutlinedInput
                labelWidth={this.state.labelWidth1}
                id="brand1"
                name="oem_1"
                className={classes.select}
              />
            }
          >
            {oemOptions[0].map(oem => (
              <MenuItem key={oem.code || 'empty'} value={oem.code}>{oem.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4} md={3}>
        <FormControl fullWidth variant="outlined" className={classes.formControl}>
          <InputLabel required ref={ref => { this.Brand2Ref = ref }} htmlFor="brand2" >
            My #2 brand is:
          </InputLabel>
          <Select
            variant="outlined"
            error={!!(showErrors && _errors.oems)}
            value={oems[1] || ''}
            onChange={e => this.setOem(1, e.target.value)}
            input={
              <OutlinedInput
                labelWidth={this.state.labelWidth2}
                id="brand2"
                name="oem_2"
                className={classes.select}
              />
            }
          >
            {oemOptions[1].map(oem => (
              <MenuItem key={oem.code || 'empty'} value={oem.code}>{oem.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4} md={3}>
        <FormControl fullWidth variant="outlined" className={classes.formControl}>
          <InputLabel ref={ref => { this.Brand3Ref = ref }} htmlFor="brand3" >
            My #3 brand is:
          </InputLabel>
          <Select
            variant="outlined"
            error={!!(showErrors && _errors.oems)}
            value={oems[2] || ''}
            onChange={e => this.setOem(2, e.target.value)}
            input={
              <OutlinedInput
                labelWidth={this.state.labelWidth3}
                id="brand3"
                name="oem_3"
                className={classes.select}
              />
            }
          >
            {oemOptions[2].map(oem => (
              <MenuItem key={oem.code || 'empty'} value={oem.code}>{oem.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" style={{marginBottom: `2em`}}>
          We suggest that you limit major brand selection to your top 2 choices.
        </Typography>
      </Grid>
    </Grid>
    )
  }


  render = () => {
    const {pricingMode} = this.props

    return (
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body1" style={{marginBottom: `2em`}}>
              A wide variety of manufacturers &amp; brands will be displayed in your
              flat rate books. To make the your books more specific to your
              company, please select additional manufacturers &amp; brands from the
              lists below, to have them displayed in your pricing books.
            </Typography>
          </Grid>

          {
            (pricingMode === 'Legacy')
            ? this.renderRegularOptions()
            : this.renderFieldEdgeOptions()
          }
        </Grid>
      </div>
    )
  }
}

EquipmentBrandForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  pricingMode: PropTypes.string
};

export default withStyles(styles)(EquipmentBrandForm);
